// @flow
import React from 'react';
import classNames from 'classnames';
import './VariantImage.css';

export type Props = {
  classes?: any,
  name: string,
  url: string,
  onRemoveImage: Function,
  onActiveImage?: Function,
};

const VariantImage = ({classes = {}, name, url, onActiveImage, onRemoveImage}: Props) => (
  <li className={classNames({
    'VariantImage': true,
    ...classes,
  })}>
    <div className="VariantImage-thumb">
      <img
        src={url}
        alt={name} />
    </div>
    <a
      className="VariantImage-thumb-link"
      onClick={() => onActiveImage && onActiveImage()}>
      {name}
    </a>
    <button
      className="VariantImage-remove-button"
      onClick={() => onRemoveImage()}>
      <i className="fa fa-close"></i>
    </button>
  </li>
);

export default VariantImage;



// WEBPACK FOOTER //
// ./src/components/VariantImage/VariantImage.js